import _ from 'lodash'
import { Getter, GetterTree } from 'vuex'
import { ModuleState, RootState } from './types'

export const offers: Getter<ModuleState, RootState> = state => {
  return state.offers
}

export const editOffer: Getter<ModuleState, RootState> = state => {
  return state.editOffer
}

export const uncaughtErrors: Getter<ModuleState, RootState> = state => {
  return state.uncaughtErrors
}

export const findBy: Getter<ModuleState, RootState> = state => {
  return (predicate: any) => _.find(state.offers, predicate)
}

export const filterBy: Getter<ModuleState, RootState> = state => {
  return (predicate: any) => _.filter(state.offers, predicate)
}

export const adoptible: Getter<ModuleState, RootState> = (
  state,
  moduleGetters,
  rootState,
  rootGetters
) => {
  return state.offers.filter(
    offer => offer!.canceled && rootGetters.currentUserId !== offer!.interviewerId
  )
}

export const upcoming: Getter<ModuleState, RootState> = (
  state,
  moduleGetters,
  rootState,
  rootGetters
) => {
  const now = state.now.toISOString()
  return state.offers!.filter(
    offer =>
      !offer!.canceled &&
      now < offer!.timeSlot!.start!.value &&
      offer!.interviewerId === rootGetters.currentUserId
  )
}

export const canceled: Getter<ModuleState, RootState> = (
  state,
  moduleGetters,
  rootState,
  rootGetters
) => {
  const now = state.now.toISOString()
  return state.offers!.filter(
    offer =>
      offer!.canceled &&
      now < offer!.timeSlot!.start!.value &&
      offer!.interviewerId === rootGetters.currentUserId
  )
}

export const notUpcoming: Getter<ModuleState, RootState> = (
  state,
  moduleGetters,
  rootState,
  rootGetters
) => {
  const now = state.now.toISOString()
  return state.offers!.filter(
    offer =>
      !(now < offer!.timeSlot!.start!.value && offer!.interviewerId === rootGetters.currentUserId)
  )
}

export const present: Getter<ModuleState, RootState> = (
  state,
  moduleGetters,
  rootState,
  rootGetters
) => {
  const now = state.now.toISOString()
  return state.offers!.filter(
    offer =>
      offer!.timeSlot!.start!.value <= now &&
      now < offer!.timeSlot!.end!.value &&
      offer!.interviewerId === rootGetters.currentUserId
  )
}

export const past: Getter<ModuleState, RootState> = (
  state,
  moduleGetters,
  rootState,
  rootGetters
) => {
  const now = state.now.toISOString()
  return state.offers!.filter(
    offer =>
      offer!.timeSlot!.end!.value <= now && offer!.interviewerId === rootGetters.currentUserId
  )
}

export const getters: GetterTree<ModuleState, RootState> = {
  adoptible,
  canceled,
  editOffer,
  filterBy,
  findBy,
  notUpcoming,
  offers,
  past,
  present,
  uncaughtErrors,
  upcoming,
}

export default getters
